module.exports = __webpack_public_path__ + "img/tit_product.3b68797d.jpg";